import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  FaUsers,
  FaClipboardList,
  FaCalendarAlt,
  FaChartLine,
} from "react-icons/fa";

const BRAND_GRADIENT = "linear-gradient(135deg, #5f2eea, #0a84ff)";

/* ================= WRAPPER ================= */

const Wrapper = styled.div`
  min-height: 100vh;
  padding: 40px 20px;
  font-family: "Poppins", sans-serif;
  color: #fff;
`;

/* ================= HEADER ================= */

const Header = styled.div`
  margin-bottom: 40px;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: ${BRAND_GRADIENT};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Subtitle = styled.p`
  color: #cbd5e1;
  margin-top: 8px;
`;

/* ================= KPI GRID ================= */

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
`;

/* ================= CARD ================= */

const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  border-radius: 18px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
`;

const IconWrapper = styled.div`
  font-size: 28px;
  margin-bottom: 16px;
`;

const CardTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 6px;
`;

const Value = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
`;

/* ================= DASHBOARD ================= */

export default function AdminDashboard() {
  return (
    <Wrapper>
      <Header>
        <Title>Admin Dashboard</Title>
        <Subtitle>Welcome back, Admin. Here's your overview.</Subtitle>
      </Header>

      <Grid>
        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaUsers />
          </IconWrapper>
          <CardTitle>Total Employees</CardTitle>
          <Value>128</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaClipboardList />
          </IconWrapper>
          <CardTitle>Customer Queries</CardTitle>
          <Value>42</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaCalendarAlt />
          </IconWrapper>
          <CardTitle>Leave Requests</CardTitle>
          <Value>7</Value>
        </Card>

        <Card whileHover={{ scale: 1.05 }}>
          <IconWrapper>
            <FaChartLine />
          </IconWrapper>
          <CardTitle>Monthly Revenue</CardTitle>
          <Value>₹4.8L</Value>
        </Card>
      </Grid>
    </Wrapper>
  );
}